import React from 'react'
import "./card.css";

function Card(props) {
  return (
    <div className={props.classProp + ' card-module'} >
      <div className='card-module--header'> 
        <p className='card-description--text'>{props.type} </p>
        <p className='card-description--text'>Show More</p>
      </div>
      <div className="card-module--body">
        <img className='icon' src={props.iconUrl} alt={props.iconAlt} />
        <div>
        <p className={props.titleColor + ' card-title--text'}>{props.title} </p>
        <p className="card-description--text ">{props.description} </p>
        </div>
        
      </div>


    </div>
  )
}

export default Card

